import { ajax } from "rxjs/ajax";
import { push } from "connected-react-router";
import config from "config";
import { request } from "boot/request";

const location = window.location;
const url = config.backendUrl;

//we can add functions that we want to
//pass to the epics from here
const utils = {};

export { ajax, location, utils, config, url, push, request };
